'use client';
import React, { useState } from 'react';
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { IoSparklesSharp } from "react-icons/io5";
import { LaunchListPanel } from '@/components/common/LaunchListPanel';

type PrimaryButton = {
  text: string;
  href: string;
};

type SecondaryButton = {
  text: string;
  href: string;
};

interface HeroButtonsProps {
  primaryButton: PrimaryButton;
  secondaryButton?: SecondaryButton;
}

export function HeroButtons({ primaryButton, secondaryButton }: HeroButtonsProps) {
  const [isEarlyAccessOpen, setIsEarlyAccessOpen] = useState(false);

  return (
    <>
      <div className="lg:order-3 order-3 mt-10 lg:mt-6 mb-12 lg:mb-0 flex items-center gap-x-4 sm:gap-x-6">
        <a
          href={primaryButton.href}
          className="text-custom-white inline-flex items-center rounded-md bg-meteor-shower px-4 sm:px-5 py-2.5 sm:py-3 text-sm sm:text-base font-bold shadow-lg hover:bg-venetian-night focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-meteor-shower transition-all duration-200 hover:shadow-xl"
        >
          {primaryButton.text}
          <ArrowRightIcon className="ml-1 w-4 h-4 sm:w-5 sm:h-5" />
        </a>
        {secondaryButton && (
          <a
            href={secondaryButton.href}
            className="text-custom-white inline-flex items-center rounded-md bg-gradient-to-r from-[var(--color-accent)] to-[var(--color-accent-secondary)] px-4 sm:px-5 py-2.5 sm:py-3 text-sm sm:text-base font-bold shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-meteor-shower transition-all duration-200 hover:brightness-110 hover:shadow-xl"
          >
            {secondaryButton.text}
            <IoSparklesSharp className="ml-1 h-4 w-4 sm:h-5 sm:w-5" aria-hidden />
          </a>
        )}
      </div>

      {/* LaunchList signup panel */}
      <LaunchListPanel
        open={isEarlyAccessOpen}
        onClose={() => setIsEarlyAccessOpen(false)}
      />
    </>
  );
}
